import { render, staticRenderFns } from "./room-type.vue?vue&type=template&id=253976a7&scoped=true"
import script from "./room-type.vue?vue&type=script&lang=js"
export * from "./room-type.vue?vue&type=script&lang=js"
import style0 from "./room-type.vue?vue&type=style&index=0&id=253976a7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253976a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('253976a7')) {
      api.createRecord('253976a7', component.options)
    } else {
      api.reload('253976a7', component.options)
    }
    module.hot.accept("./room-type.vue?vue&type=template&id=253976a7&scoped=true", function () {
      api.rerender('253976a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/room-type.vue"
export default component.exports